/**
 * Constants for the Proposal Detail feature
 */
// Namespace for translations
export const namespace = 'features.proposals.proposal_detail';
// Field labels - these will be populated from translations
export const fieldLabels = {
    priceList: 'fields.price_list',
    projectName: 'fields.project_name',
    proposalNumber: 'fields.proposal_number',
    proposalDate: 'fields.proposal_date',
    proposalType: 'fields.proposal_type',
    building: 'fields.building',
    summary: 'summary',
    scopeOfWork: 'scope_of_work',
    exclusions: 'exclusions',
    termsAndConditions: 'terms_conditions'
};
export const richTextSectionFields = ['summary', 'scopeOfWork', 'exclusions', 'termsAndConditions'];
